<template>
  <v-container fluid v-if="hasAccessToPage">
    <!-- Inventory table -->
    <v-row justify="center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="10">
        <InventoryTable />
      </v-col>
    </v-row>
  </v-container>
  <NoAccessMessage v-else />
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';
import InventoryTable from '@/views/VaccineViews/VaccineInventoryPage/components/inventory-table.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    NoAccessMessage,
    InventoryTable
  },
  data() {
    return {
      hasAccessToPage: false,
      selectedItem: null
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  }
};
</script>

<style></style>
